var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldGridEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m18.73 14.67-4.15 4.15c-.16.16-.31.47-.35.69L14 21.1c-.08.57.32.98.89.89l1.59-.23c.22-.03.53-.19.69-.35l4.15-4.15c.73-.71 1.06-1.54.01-2.59-1.05-1.05-1.88-.71-2.6 0zM6.75 7.8H3.498a1 1 0 0 1-.907-1.423C3.947 3.471 5.666 2.012 7.75 2v4.8a1 1 0 0 1-1 1zM16.25 6.8V3.438a1 1 0 0 1 1.385-.923c2.629 1.098 4.06 2.486 4.295 4.165.08.59-.4 1.12-1 1.12h-3.68a1 1 0 0 1-1-1zM7.616 21.173c-.314.545-.646.794-.996.748-2.89-.43-4.58-2.46-4.62-5.62h4.75a1 1 0 0 1 1 1v3.372a1 1 0 0 1-.134.5zM2 10.3v3.5a1 1 0 0 0 1 1h3.75a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zM9.25 10.3v3.5a1 1 0 0 0 1 1h3.27a1 1 0 0 0 .47-.116c.506-.269.76-.563.76-.883v-3.5a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1zM9.25 3v3.8a1 1 0 0 0 1 1h3.5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-3.5a1 1 0 0 0-1 1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldGridEdit);
export default __webpack_public_path__ + "static/media/vuesax-bold-grid-edit.2161b7e86f316e627fa1b007832cbbde.svg";
export { ForwardRef as ReactComponent };